/** Use when check if want to edit customer info only or customer info and job site
 * In case of single job site or multi job site.
 * Can be used to show/hide section of edit customer component
 */

export enum LoadingState{
	NotLoaded = 0,
	Loaded = 1,
	LoadedWithError = 2
}

export enum CustomerEditType {
	Billing = 1,
	BillingAndJobSite = 2
}

/** use for inner tabbing in edit customer info and job site(in case of multi job sites) */
export enum TabType {
	CustomerBilling = 0,
	JobSite = 1
}

export enum CustomerType {
	Individual = 0,
	Company = 1
}

/** used for refreshing work orders on landing pages based on destination  */
export enum WOSChangeEventDestination {
	WOLanding = 0,
	WOReviewLanding = 1
}

export enum EquipmentFormMode {
  Add = 0,
  Edit = 1,
  Duplicate = 2
}

/** Work order payment methods */
export enum PaymentType {
  None = 0,
  CreditCard = 1,
  Cash = 2,
  Cheque = 3,
  Other = 4
}

export enum ProductItemType {
	Service = "Service",
	Material = "Material",
	Labor = "Labor",
	Agreement = "Agreement"
}

export enum ExportType {
	Excel = 1,
	CSV = 2, 
	PDF = 3
}